import { Component, Input, ViewChild, OnChanges, AfterViewInit,  AfterViewChecked } from '@angular/core';
import { IonicPage, Content } from 'ionic-angular';
import { ScrollDetail } from '@ionic/core';
import {html} from '../html/html';
import { ModalController,NavParams } from 'ionic-angular';

@Component({
  selector: 'pago',
  templateUrl: 'pago.html'
})
export class pago {
  @Input() data: any;
  @Input() events: any;
  @ViewChild(Content)
  content: Content;

  //str_html ='<h2 style="text-align:center">Tu especialista</h2> <div class="card"> <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Circle-icons-profile.svg/1024px-Circle-icons-profile.svg.png" alt="John" style="width:40%"> <h1>Marta Saltos</h1> <p class="title">Av Sucre y Rocafuerte</p> <p>Portoviejo Manabí</p> <div style="margin: 24px 0;"> <a href="#"><i class="fa fa-dribbble"></i></a> <a href="#"><i class="fa fa-twitter"></i></a> <a href="#"><i class="fa fa-linkedin"></i></a> <a href="#"><i class="fa fa-facebook"></i></a> </div> <p><a   href="tel:+593991609510" class="boton"></a></p> </div>';
  str_html=' <div class="invoice-box"> <table cellpadding="0" cellspacing="0"> <tr class="top"> <td colspan="2"> <table> <tr> <td class="title"> <img src="assets/images/logo/2.png" style="width:100%; max-width:300px;"> </td> <td> Factura #: 0001<br> Fecha: ENERO 06-2019<br> </td> </tr> </table> </td> </tr> <tr class="information"> <td colspan="2"> <table> <tr> <td> OcreApp.<br> Crystian Bravo<br> ventas@ocreapp.com </td> </tr> </table> </td> </tr> <tr class="heading"> <td> Metodo Pago </td> <td> EFECTIVO # </td> </tr> <tr class="details"> <td> Pagado </td> <td> </td> </tr> <tr class="heading"> <td> Item </td> <td> Valor </td> </tr> <tr class="item"> <td> Acrílicas Esculpidas </td> <td> $34.00 </td> </tr> <tr class="item"> <td> Manos </td> <td> $5.50 </td> </tr> <tr class="item last"> <td> Acrílicas con Extensión </td> <td> $24.00 </td> </tr> <tr class="total"> <td></td> <td> Total: $63.50 </td> </tr> </table> </div>';
 


  headerImage:any = "";
  active=false;
  color="transparente";
  showToolbar = true;

  pagina={
    headerTitle:"Tus Pagos",
    fondo:"assets/images/app/fondo.jpg",
       items:[
      {
      title:"FACT001",
      subtitle:"27/08/2018 ",
      total:"50.33",
      html:this.str_html
    },
    {
    title:"FACT002",
    subtitle:"27/08/2018 ",
    total:"57.33",
    html:this.str_html
  },
  {
  title:"FACT003",
  subtitle:"27/08/2018 ",
  total:"55.33",
  html:this.str_html
}


    ]

  }
  constructor(private modalCtrl:ModalController) {


  }

  onEvent(event: string, item: any, e: any) {
    console.log("evento");
  }



  ngOnChanges(changes: { [propKey: string]: any }) {
    console.log("change");

  }



  openHtml(str_html){

    let item ={
      titulo:'Detalle pago',
      html:str_html
    }
  
      console.log("modal");
       let modal = this.modalCtrl.create(html,{"item":item },{cssClass: ""});
      //let modal = this.modalCtrl.create(html,{"item":item },{cssClass: ""});

      // modal.onDidDismiss(data => {
    
      //   if (data.dato) {
          
      //      }
      //      console.log(JSON.stringify(data));
      //    });
      modal.present();
    
    
    
  }


}



// WEBPACK FOOTER //
// ./src/pages/pago/pago.ts